const SELECT_ACTION  = 'automation/SELECT_ACTION'
const SELECT_EVENT  = 'automation/SELECT_EVENT'

export const types = {
  SELECT_ACTION,
  SELECT_EVENT
}

export const selectAction = (actionName) => ({ type: SELECT_ACTION, actionName })
export const selectEvent = (eventName) => ({ type: SELECT_EVENT, eventName })